import type { NavLinkItem } from 'Components/Layout/DrawerMenu/types'
import BasicLayout from 'Components/Layout/Templates/BasicLayout'
import DeviceRoot from 'Services/ServiceProviderManagement/Features/Device'
import { SalesPointRoot } from 'Services/ServiceProviderManagement/Features/SalesPoint'
import ServiceProviderRoot from 'Services/ServiceProviderManagement/Features/ServiceProvider'
import { SELECTED_PTA_STORAGE_KEY, SERVICE_PROVIDER_MANAGEMENT_ROOT_URL } from 'Util/constants'
import ApartmentIcon from '@mui/icons-material/Apartment'
import ComputerIcon from '@mui/icons-material/Computer'
import PlaceIcon from '@mui/icons-material/Place'
import { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { t } from 'ttag'

function ServiceProviderManagement() {
  // Service provider management does not require PTA selection anymore. PTA can be accidentally
  // left selected, when navigating from product management to service provider management.
  useEffect(() => {
    localStorage.removeItem(SELECTED_PTA_STORAGE_KEY)
  }, [])

  const menuBarNavLinks: NavLinkItem[] = [
    {
      title: t`Service providers`,
      link: `${SERVICE_PROVIDER_MANAGEMENT_ROOT_URL}/service-providers`,
      icon: <ApartmentIcon fontSize="small" />
    },
    {
      title: t`Sale point infos`,
      link: `${SERVICE_PROVIDER_MANAGEMENT_ROOT_URL}/sales-points`,
      icon: <PlaceIcon fontSize="small" />
    },
    {
      title: t`Device infos`,
      link: `${SERVICE_PROVIDER_MANAGEMENT_ROOT_URL}/devices`,
      icon: <ComputerIcon fontSize="small" />
    }
  ]

  return (
    <Routes>
      <Route element={<BasicLayout menuBarNavLinks={menuBarNavLinks} />} path="/">
        <Route index element={<Navigate to="service-providers/" />} />
        <Route path="/service-providers/*" element={<ServiceProviderRoot />} />
        <Route path="/sales-points/*" element={<SalesPointRoot />} />
        <Route path="/devices/*" element={<DeviceRoot />} />
      </Route>
    </Routes>
  )
}

export default ServiceProviderManagement
